<template>
  <section id="beforeAfter">

    <div class="box--wrapper">
      <div class="container">
        <div v-for="section in sections" :key="section.type" class="slideWrapper">
          <div class="d-flex justify-content-center mb-4 procedure-heading" data-aos="fade-in" id="rhinoplasty">
            <h3><a :href="section.link" class="link link--basic"><span>{{ section.type }}</span></a></h3>
          </div>
          
          <before-after-slider :entries="section.entries" :section="section" />

            <!-- Before / After Modals -->
              <div v-for="patient in section.entries" :key="patient.image" id="beforeAfterModals">

                <before-after-modal :patient="patient" :section="section" />
                
              </div>
            <!-- Before / After Modals END -->

          <div class="row d-flex justify-content-between" data-aos="fade-in">
            <div class="col-12 view-all--link d-flex justify-content-end">
              <a :href="section.link" class="link link--basic">Learn more about the procedure <i class="fa-regular fa-angles-right ms-3"></i></a>
            </div>
          </div>          
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  const sections = require('../sliders.json')
  export default ({
    setup() {
      return {
        sections
      }
    },
  })
</script>